<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [footer]="footer"
  [width]="width"
  [data]="data"
  [title]="data.headline">
  <ng-template #content>
    <div class="flex flex-col gap-5 text-base leading-6">
      <p>{{ cmsTextProvider.appearanceText.fontResetDescription }}</p>
      <p>{{ cmsTextProvider.appearanceText.fontResetHint }}</p>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="flex w-full justify-end gap-3">
      <aw-button
        id="cancel-font-reset"
        type="button"
        [isFullWidth]="false"
        [style]="'primary-alt'"
        [text]="cmsTextProvider.shared.cancel"
        (click)="dialogRef.close()" />
      <aw-button
        id="confirm-font-reset"
        type="button"
        [isFullWidth]="false"
        [text]="cmsTextProvider.appearanceText.fontRestore"
        (click)="
          dialogRef.close({ submit: true, data, acceptChanges: false })
        " />
    </div>
  </ng-template>
</aw-dialog>
